module.exports = __webpack_public_path__ + "static/2-49fd894b645732070f120e171dcbbfb4.png";